"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GuideCardMobile = exports.GuideCardDesktop = void 0;
var _react = _interopRequireDefault(require("react"));
var _CloudinaryPicture = _interopRequireDefault(require("../CloudinaryPicture"));
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } //components
//styled-components
var GuideCardBase = function GuideCardBase(_ref) {
  var device = _ref.device,
    imageSizes = _ref.imageSizes,
    guide = _ref.guide,
    params = _ref.params,
    _ref$shouldShowSpinne = _ref.shouldShowSpinnerWhileLoading,
    shouldShowSpinnerWhileLoading = _ref$shouldShowSpinne === void 0 ? false : _ref$shouldShowSpinne,
    _ref$shouldShowAnimat = _ref.shouldShowAnimationWhileLoading,
    shouldShowAnimationWhileLoading = _ref$shouldShowAnimat === void 0 ? false : _ref$shouldShowAnimat,
    store = _ref.store,
    route = _ref.route;
  var imageUrl = guide.imageUrl,
    title = guide.title;
  var isLink = store && store.router && route;
  var isMobile = device === 'mobile';
  var GuideCard = isLink ? _styles.GuideCardLink : _styles.GuideCardStatic;
  var Heading = isMobile ? _styles.HeadingMobile : _styles.HeadingDesktop;
  var metadata = guide.metadata ? guide.metadata : guide.media && guide.media.metadata ? guide.media.metadata : {};
  var dataCyGuideTitle = "guide-title-".concat(title.split(' ').join('-'));
  return /*#__PURE__*/_react["default"].createElement(GuideCard, {
    store: store,
    route: route,
    params: params,
    isLink: isLink,
    device: device,
    "data-cy": "guide-card"
  }, /*#__PURE__*/_react["default"].createElement(_CloudinaryPicture["default"], {
    aspectRatio: 4 / 3,
    metadata: metadata,
    shouldShowSpinnerWhileLoading: shouldShowSpinnerWhileLoading,
    shouldShowAnimationWhileLoading: shouldShowAnimationWhileLoading,
    src: imageUrl,
    sizes: imageSizes
  }), /*#__PURE__*/_react["default"].createElement(Heading, {
    maxLines: 3,
    dataCy: dataCyGuideTitle
  }, title));
};
var GuideCardDesktop = exports.GuideCardDesktop = function GuideCardDesktop(props) {
  return /*#__PURE__*/_react["default"].createElement(GuideCardBase, _extends({
    device: "desktop"
  }, props));
};
var GuideCardMobile = exports.GuideCardMobile = function GuideCardMobile(props) {
  return /*#__PURE__*/_react["default"].createElement(GuideCardBase, _extends({
    device: "mobile"
  }, props));
};
//# sourceMappingURL=index.js.map